import type {ReactElement} from 'react';
import React from 'react';
import type {StockFilterID, StockSubfilter} from '@Panels/stock-panel/stock-panel.types';
import {SeasonSearchSubFilterId, StockButtonFilters} from '@Panels/stock-panel/stock-panel.types';
import type {StockFilterListItem} from '@Panels/stock-panel/components/stock-filter-button/stock-filter-button.types';
import {PillButton} from '@Components/pill-button';
import type {PillButtonSize} from '@Components/pill-button/pill-button.types';
import styles from './stock-filter-pill-button.module.scss';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {SeasonalDecorationEmoji} from '@Utils/seasonal-promotion.util';

export interface StockFilterPillButtonProps {
  id: StockFilterID;
  subfilters: StockFilterListItem[];
  selectedSubfilterID?: string;
  pillSize: PillButtonSize;
  className?: string;

  onSubFilterClicked(filterID: StockFilterID, subFilterID?: string): void;
}

export function StockFilterPillButton({...props}: StockFilterPillButtonProps): ReactElement | null {
  const getSeasonalPill = (subfilter: StockSubfilter): ReactElement | null => {
    return (
      <li
        key={subfilter.id}
        className={`radius-round border-s-darker flex-center spacing-p-l-4 hover-transition-all spacing-p-0 ${styles.seasonalPill} ${subfilter.id === selectedItemID ? `spacing-p-r-2 ${styles.selected}` : 'spacing-p-r-4'}`}
        onClick={() => {
          if (subfilter.id !== selectedItemID) {
            props.onSubFilterClicked(props.id, subfilter.id);
          }
        }}
      >
        <Text
          val={subfilter.id === SeasonSearchSubFilterId.Halloween.valueOf() ? SeasonalDecorationEmoji.HALLOWEEN : SeasonalDecorationEmoji.CHRISTMAS}
          size={TextSize.XSMALL}
          className={'spacing-p-r-2'}
        />
        <Text
          val={subfilter.text}
          size={TextSize.XSMALL}
          className={subfilter.id === SeasonSearchSubFilterId.Halloween.valueOf() ? 'content-halloween' : 'content-christmas'}
          bold
        />
        {subfilter.id === selectedItemID ? (
          <Icon
            size={IconSize.SIZE_ICON_16}
            icon="icon-close"
            className="content-primary spacing-m-l-2"
            onClick={(): void => {
              props.onSubFilterClicked(props.id);
            }}
          />
        ) : null}
      </li>
    );
  };
  const selectedItemID = props.selectedSubfilterID
    ? props.subfilters.find((subfilter) => {
        return subfilter.id === props.selectedSubfilterID;
      })?.id
    : undefined;

  return (
    <ul className={`flex-h-row spacing-m-0 ${styles.filtersList} ${props.className ?? ''}`}>
      {props.subfilters.map((subfilter) => {
        if (props.id === StockButtonFilters.SEASONAL) {
          return getSeasonalPill(subfilter);
        }
        return (
          <li key={subfilter.id} className="spacing-p-0 _full-height _full-width">
            {subfilter.id === selectedItemID ? (
              <PillButton
                isSelected
                size={props.pillSize}
                text={subfilter.text}
                onClick={() => {}}
                onClose={() => {
                  props.onSubFilterClicked(props.id);
                }}
              />
            ) : (
              <PillButton
                size={props.pillSize}
                text={subfilter.text}
                onClick={() => {
                  props.onSubFilterClicked(props.id, subfilter.id);
                }}
              />
            )}
          </li>
        );
      })}
    </ul>
  );
}
